import playCircle from "../../../../assets/play-circle.svg";
import RightArrow from "../../../../assets/arrow-right.svg";
import { Handle } from "@xyflow/react";
export default function IncomingCallTriggerNode ({data, selected, id}) {
	return (
		<div style={{
			display: "inline-block",
			borderRadius: 8,
			padding: selected ? 4 : 0,
			boxShadow: selected ? "0px 0px 3.01px 3.01px #34CB65, 0px 0px 0px 1.5px #FFFFFF" : "0 0 0 0 #fff",
			transition: "box-shadow 0.3s, padding 0.3s, border 0.3s",
			backgroundColor: "transparent"
		}}>
			<div style={{ width: nodeDimensions.width, border: "1px solid #E0E0E0", borderRadius: "8px", backgroundColor: "#FFFFFF", overflow: "hidden" }}>
			<div style={{ height: "6px", backgroundColor: "#56D27E", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }} />
			<div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "18px 20px 12px 20px" }}>
				<div style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: "#E5F6EE", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<img src={playCircle} alt="Play" style={{ width: "20px", height: "20px" }} />
				</div>
				<div className="t6 nc-gray-900 medium-font" style={{textDecoration: selected ? "underline" : "none"}}>Trigger</div>
			</div>
			<div style={{ height: "1px", backgroundColor: "#E0E0E0" }} />
			<div className="t7 nc-gray-900 medium-font" style={{ padding: "20px", height: "100px" }}>
				Incoming call on
				<img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
				<span style={{ fontWeight: "500" }}>{data.countryCode} {data.phoneNumber}</span>
			</div>
			<div style={{ height: "1px", backgroundColor: "#E0E0E0" }} />
			<div className="t7 nc-gray-900 medium-font" style={{ padding: "16px", textAlign: "center" }}>Incoming call</div>
			</div>
			<Handle type="source" position="bottom" style={localStyles.handle} />
		</div>
	)
}

const nodeDimensions = { width: "352px" };
const localStyles = {
	img: {
		width: 16,
		height: 16,
	},
	container: {
		width: nodeDimensions.width,
		border: "1px solid #E0E0E0",
		borderRadius: 8,
		backgroundColor: "#fff"
	},
	handle: {
		background: "#555" },
}